import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function MegaMenu({ sections, isOpen }) {
  if (!isOpen) return null;

  return (
    <div 
      className="absolute top-full left-1/2 mt-1 w-[640px] bg-white dark:bg-slate-900 border border-stone-200 dark:border-slate-800 rounded-2xl shadow-2xl z-50 p-8 animate-mega-enter"
      role="menu"
    >
      <div className="grid grid-cols-2 gap-12">
        {sections.map((section, idx) => (
          <div key={idx} className="flex flex-col gap-4">
            <h3 className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest mb-1">
              {section.title}
            </h3>
            <div className="flex flex-col gap-1">
              {section.items.map((item, itemIdx) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={itemIdx}
                    to={item.to}
                    className="group flex items-center gap-3 p-2 -mx-2 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-all duration-200"
                    role="menuitem"
                  >
                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 transition-transform group-hover:scale-110 ${item.iconBg || 'bg-slate-100 dark:bg-slate-800'}`}>
                      <Icon size={18} className={item.iconColor || 'text-slate-600 dark:text-slate-400'} strokeWidth={2} aria-hidden="true" />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-brand-600 dark:group-hover:text-brand-400 transition-colors">
                        {item.label}
                      </span>
                    </div>
                    <ChevronRight size={14} className="ml-auto opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-brand-50" aria-hidden="true" />
                  </Link>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      
      {/* Decorative arrow */}
      <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-white dark:bg-slate-900 border-t border-l border-stone-200 dark:border-slate-800 rotate-45" />
    </div>
  );
}
